import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

interface DealerValuePayload {
    name: string;
    description?: string;
    // Add more fields as needed based on your API requirements
}

class DealerValues {
    static ENDPOINT = 'api/v2/dealer-values';

    static async getDealerValue(dealerValueId: string): Promise<APIResponseType> {
        if (!dealerValueId) throw new Error("Dealer Value ID is required to fetch details");
        try {
            const response = await apiService.get<APIResponseType>(`${this.ENDPOINT}/${dealerValueId}`);
            return response;
        } catch (error) {
            throw error;
        }
    }

    static async getAllDealerValues(): Promise<APIResponseType> {
        try {
            const response = await apiService.get<APIResponseType>(`${this.ENDPOINT}`);
            return response;
        } catch (error) {
            throw error;
        }
    }

    static async addDealerValue(payload: DealerValuePayload): Promise<APIResponseType> {
        try {
            console.log("API Service - addDealerValue called with payload:", payload);
            const response = await apiService.post<APIResponseType>(`${this.ENDPOINT}`, payload);
            await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
            return response;
        } catch (error) {
            console.error("API Service - addDealerValue error:", error);
            throw error;
        }
    }

    static async deleteDealerValue(dealerValueId: string): Promise<APIResponseType> {
        if (!dealerValueId) throw new Error("Dealer Value ID is required for deletion");
        try {
            const response = await apiService.delete<APIResponseType>(`${this.ENDPOINT}/${dealerValueId}`);
            await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
            return response;
        } catch (error) {
            throw error;
        }
    }

    static async editDealerValue(dealerValueId: string, payload: Partial<DealerValuePayload>): Promise<APIResponseType> {
        if (!dealerValueId) throw new Error("Dealer Value ID is required for editing");
        if (!Object.keys(payload).length) throw new Error("Edit payload cannot be empty");

        try {
            const response = await apiService.put<APIResponseType>(`${this.ENDPOINT}/${dealerValueId}`, payload);
            await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
            return response;
        } catch (error) {
            throw error;
        }
    }
}

export default DealerValues; 